import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { RolesPartidosService } from '../../services/roles-partidos/roles-partidos.service';
import { Socket } from 'ngx-socket-io';

declare const $:any;

/* Marcador del partido para ponerlo encima de la transmision (fuente "Web" de Prism Live Studio u OBS).
   Es el enlace que copia Rol de Partidos. El fondo queda transparente para que solo se vea la franja
   sobre la camara. El marcador lo manda en vivo la planilla de la tablet: la pagina entra a la sala
   del partido en el servidor y, al abrirse o reconectarse, le pide a la tablet el marcador actual,
   porque en la base recien queda al procesar el cierre. El logo del campeonato va arriba a la derecha.
   Con ?posicion=abajo la franja va al pie y con ?logo=izquierda el logo pasa a la esquina izquierda
   (se pueden juntar: ?posicion=abajo&logo=izquierda). */
@Component({
    selector: 'app-consulta-marcador-partido',
    templateUrl: './consulta-marcador-partido.component.html',
    styleUrls: ['./consulta-marcador-partido.component.css'],
    standalone: false
})
export class ConsultaMarcadorPartidoComponent extends BaseComponent implements OnInit, OnDestroy {

  id_partido:any;
  partido:any;
  //lo ultimo que mando la tablet; mientras no llegue nada se muestra lo que hay en la base
  vivo:any=null;
  posicion='arriba';
  //logo del campeonato en la esquina superior derecha, o la izquierda con ?logo=izquierda
  campeonato:any=null;
  esquina_logo='derecha';
  //resalta un momento el numero que cambio
  destello=[false,false];
  logo_fallido=[false,false];
  private suscripciones:Subscription[]=[];
  private temporizadores:any[]=[];

  constructor(private _Activatedroute:ActivatedRoute,
    private router: Router,
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    public rolesPartidosService:RolesPartidosService,
    public socket:Socket) {
      super(persistenciaService,modalService,generalService,usuarioService);
     }

  ngOnInit(): void {
    $('html, body, .body-container').css({'background-image':'none','background-color':'transparent'});
    this.id_partido=this._Activatedroute.snapshot.paramMap.get("id_partido");
    this.posicion=this._Activatedroute.snapshot.queryParamMap.get("posicion")=="abajo"?"abajo":"arriba";
    this.esquina_logo=this._Activatedroute.snapshot.queryParamMap.get("logo")=="izquierda"?"izquierda":"derecha";
    this.obtenerPartido();
    this.obtenerCampeonato();
    let entrar=() => {
      this.socket.emit('unirseMarcadorPartido',{id_partido:Number(this.id_partido)});
      this.socket.emit('pedirMarcadorEnVivo',{id_partido:Number(this.id_partido)});
    };
    this.suscripciones.push(
      this.socket.fromEvent('connect').subscribe(() => entrar()),
      this.socket.fromEvent('marcadorEnVivo').subscribe((dato:any) => this.recibirMarcador(dato))
    );
    if(this.socket.ioSocket?.connected) entrar();
  }

  ngOnDestroy(): void {
    this.suscripciones.forEach(suscripcion => suscripcion.unsubscribe());
    this.temporizadores.forEach(temporizador => clearTimeout(temporizador));
    this.socket.emit('salirMarcadorPartido',{id_partido:Number(this.id_partido)});
  }

  //sin blockUI: la pagina va dentro de la transmision
  obtenerPartido(){
    this.rolesPartidosService.obtenerPartido(this.id_partido).subscribe((res:any)=>{
      if(res && !res.tiene_error) this.partido=res;
    });
  }

  obtenerCampeonato(){
    this.rolesPartidosService.obtenerCampeonatoPartido(this.id_partido).subscribe((res:any)=>{
      if(res && !res.tiene_error) this.campeonato=res;
    });
  }

  logoCampeonato(){
    return this.campeonato && this.campeonato.logo?this.rest_server+this.campeonato.logo:null;
  }

  recibirMarcador(dato){
    if(!dato || dato.id_partido!=this.id_partido) return;
    let anterior=[this.marcador(0),this.marcador(1)];
    this.vivo=dato;
    [0,1].forEach(lado => {
      if(anterior[lado]!==null && anterior[lado]!==this.marcador(lado)) this.destellar(lado);
    });
  }

  destellar(lado){
    this.destello[lado]=false;
    this.temporizadores.push(setTimeout(() => {
      this.destello[lado]=true;
      this.temporizadores.push(setTimeout(() => this.destello[lado]=false,1200));
    },0));
  }

  equipo(lado){
    return this.partido?(lado==0?this.partido.equipo_1:this.partido.equipo_2):null;
  }

  nombreEquipo(lado){
    let equipo=this.equipo(lado);
    if(equipo && equipo.nombre) return equipo.nombre;
    return this.vivo?(lado==0?this.vivo.equipo_1.nombre:this.vivo.equipo_2.nombre):'';
  }

  logoEquipo(lado){
    let equipo=this.equipo(lado);
    return equipo && equipo.logo && !this.logo_fallido[lado]?this.rest_server+equipo.logo:null;
  }

  //un logo que no carga no se muestra: en la transmision saldria el icono de imagen rota
  logoFallido(lado){
    this.logo_fallido[lado]=true;
  }

  marcador(lado){
    let fuente=this.vivo || this.partido;
    if(!fuente) return null;
    let valor=lado==0?fuente.marcador_equipo_1:fuente.marcador_equipo_2;
    return valor===null || valor===undefined?null:Number(valor);
  }

  esVoleibol(){
    return this.vivo?this.vivo.disciplina=="VOLEIBOL":false;
  }

  /* Debajo del marcador: el periodo en juego ("2º tiempo", "3º cuarto") o, en voleibol, el set con sus
     puntos (el marcador grande son los sets ganados). Solo con datos de la tablet. */
  textoPeriodo(){
    if(!this.vivo) return '';
    if(this.vivo.terminado) return 'FINAL';
    if(this.esVoleibol()) return this.vivo.periodo+' · '+(this.vivo.puntos_set_equipo_1 ?? 0)+' - '+(this.vivo.puntos_set_equipo_2 ?? 0);
    return this.vivo.periodo || '';
  }

}
